/*
 * AOP cart helpers
 * - Cart drawer shows automatic discounts (Spooky Deals) clearly
 * - Fires "aop:cart-updated" after every refresh so other sections can react
 * Loaded with `defer` from sections/cart-drawer.liquid, so it runs after the inline
 * script in layout/theme.liquid and replaces its refreshCartDrawerContents / initCartDrawerButtons.
 */
(function () {
  'use strict';

  var EMPTY_HTML =
    '<div class="cart-drawer-empty"><svg width="48" height="48" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24" opacity="0.3"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg><div style="font-family:var(--font-display);letter-spacing:.1em">YOUR CART IS EMPTY</div><p>Add some art to get started.</p></div>';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(cents, cur) {
    var n = (Math.round(cents || 0) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + n + (cur ? ' ' + cur : '');
  }

  // Group line-level + order-level discounts by title -> [{title, amount}]
  function discountRows(cart) {
    var totals = {};
    var order = [];
    function add(title, amount) {
      if (!amount) return;
      title = title || 'Discount';
      if (!(title in totals)) { totals[title] = 0; order.push(title); }
      totals[title] += amount;
    }
    (cart.items || []).forEach(function (it) {
      (it.discounts || []).forEach(function (d) { add(d.title, d.amount); });
    });
    (cart.cart_level_discount_applications || []).forEach(function (d) {
      add(d.title, d.total_allocated_amount);
    });
    return order.map(function (t) { return { title: t, amount: totals[t] }; });
  }

  function itemHTML(it, cur) {
    var variant = it.variant_title && it.variant_title !== 'Default Title'
      ? '<div class="cart-drawer-variant">' + esc(it.variant_title) + '</div>' : '';
    var lineDisc = (it.original_line_price || 0) - (it.final_line_price || 0);
    var deal = lineDisc > 0
      ? '<div class="cd-deal-badge">\uD83C\uDF83 DEAL APPLIED \u00B7 \u2212' + money(lineDisc) + '</div>' : '';
    var img = it.image
      ? '<img src="' + esc(it.image) + '" alt="' + esc(it.product_title) + '" class="cart-drawer-img">' : '';
    return '<div class="cart-drawer-item" data-key="' + esc(it.key) + '">' + img +
      '<div class="cart-drawer-info">' +
        '<a href="' + esc(it.url) + '" class="cart-drawer-title-sm">' + esc(it.product_title) + '</a>' +
        variant +
        '<div style="font-size:12px;color:rgba(15,15,16,.7);margin-top:2px">' + money(it.original_price, cur) + '</div>' +
        deal +
        '<div class="cart-drawer-actions">' +
          '<div class="qty-ctrl sm">' +
            '<button type="button" class="cart-upd" data-key="' + esc(it.key) + '" data-delta="-1">\u2212</button>' +
            '<span>' + it.quantity + '</span>' +
            '<button type="button" class="cart-upd" data-key="' + esc(it.key) + '" data-delta="1">+</button>' +
          '</div>' +
          '<button type="button" class="cart-remove" data-key="' + esc(it.key) + '" aria-label="Remove">' +
            '<svg width="16" height="16" fill="none" stroke="var(--pink)" stroke-width="2" viewBox="0 0 24 24"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>' +
          '</button>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  function renderFooter(cart, cur) {
    var subEl = document.getElementById('drawer-subtotal');
    var label = document.getElementById('drawer-subtotal-label');
    var box = document.getElementById('drawer-savings');
    if (subEl) subEl.textContent = money(cart.total_price, cur);
    if (!box) return;
    var saved = cart.total_discount || 0;
    if (cart.item_count > 0 && saved > 0) {
      var rows = discountRows(cart).map(function (d) {
        return '<div class="cd-row cd-disc"><span>\uD83C\uDF83 ' + esc(d.title) + '</span><span>\u2212' + money(d.amount, cur) + '</span></div>';
      }).join('');
      box.innerHTML =
        '<div class="cd-row"><span>Items</span><span>' + money(cart.original_total_price, cur) + '</span></div>' +
        rows +
        '<div class="cd-saved">\uD83C\uDF89 You\u2019re saving ' + money(saved, cur) + '</div>';
      box.hidden = false;
      if (label) label.textContent = 'TOTAL';
    } else {
      box.innerHTML = '';
      box.hidden = true;
      if (label) label.textContent = 'SUBTOTAL';
    }
  }

  function changeLine(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function () {
      return window.refreshCartDrawerContents();
    });
  }

  window.refreshCartDrawerContents = function refreshCartDrawerContents() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var cur = cart.currency || '';
        ['cart-count', 'drawer-count'].forEach(function (id) {
          var el = document.getElementById(id);
          if (el) el.textContent = cart.item_count;
        });
        renderFooter(cart, cur);
        var body = document.getElementById('cart-drawer-body');
        if (body) {
          body.innerHTML = cart.item_count === 0
            ? EMPTY_HTML
            : cart.items.map(function (it) { return itemHTML(it, cur); }).join('');
          window.initCartDrawerButtons();
        }
        var checkout = document.getElementById('checkout-link');
        if (checkout) checkout.classList.toggle('disabled', cart.item_count === 0);
        document.dispatchEvent(new CustomEvent('aop:cart-updated', { detail: cart }));
        return cart;
      })
      .catch(function (err) { console.error('Cart refresh failed', err); });
  };

  // One delegated listener on the drawer body (survives re-renders)
  window.initCartDrawerButtons = function initCartDrawerButtons() {
    var body = document.getElementById('cart-drawer-body');
    if (!body || body.__aopBound) return;
    body.__aopBound = true;
    body.addEventListener('click', function (e) {
      var btn = e.target.closest('.cart-upd, .cart-remove');
      if (!btn || !body.contains(btn)) return;
      var key = btn.getAttribute('data-key');
      var qty = 0;
      if (btn.classList.contains('cart-upd')) {
        var span = btn.parentElement.querySelector('span');
        qty = Math.max(0, (parseInt(span.textContent, 10) || 0) + parseInt(btn.getAttribute('data-delta'), 10));
      }
      changeLine(key, qty);
    });
  };

  // Full cart page (templates/cart.liquid): quantity +/- buttons
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.cart-qty');
    if (!b) return;
    e.preventDefault();
    var span = b.parentElement.querySelector('span');
    var qty = Math.max(0, (parseInt(span.textContent, 10) || 0) + parseInt(b.getAttribute('data-delta'), 10));
    b.disabled = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: b.getAttribute('data-key'), quantity: qty })
    }).then(function () { window.location.reload(); }, function () { window.location.reload(); });
  });
})();